import { Theme } from '@mui/material'

const useStyles = {
  mainContentGrid: (theme: Theme) => ({
    marginY: '40px',
    height: '100%',
    minHeight: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignContent: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      marginTop: '40px',
      marginBottom: 0,
      minHeight: 'calc(100% - 40px)',
    },
  }),
  formControl: (theme: Theme) => ({
    width: '345px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
  formFieldContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  loginFormSubmitButton: (theme: Theme) => ({
    width: 'auto',
    minWidth: '55%',
    [theme.breakpoints.up('sm')]: {
      minWidth: '250px',
    },
  }),
  loginFooterWrapper: {
    marginTop: 'auto',
  },
}

export default useStyles
